// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar-module--calendar--1TPLs","calendarimg":"calendar-module--calendarimg--3agMX","date":"calendar-module--date--3PyyH"};